import { createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import { ProductCreatePage } from '@/features/products';

export const Route = createFileRoute('/_authed/_active/org/products/new')({
  staticData: { crumb: 'products:new', tours: ['catalog.product-new'] },
  beforeLoad: ({ context }) => {
    requirePermission(context.me, 'products.write');
  },
  component: ProductCreatePage,
});
